import { render, staticRenderFns } from "./RoundRobinMatch.vue?vue&type=template&id=581b7bed&scoped=true"
import script from "./RoundRobinMatch.vue?vue&type=script&lang=js"
export * from "./RoundRobinMatch.vue?vue&type=script&lang=js"
import style0 from "./RoundRobinMatch.vue?vue&type=style&index=0&id=581b7bed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b7bed",
  null
  
)

export default component.exports